<template>
  <section class="ReFPSignUp PersoanlDetail-signUp">
    <div class="PersoanlDetail_header">
      <div class="flex-between">
        <h2 class="createAccount_title">{{ $t('checkout.personalDetails.common.createAccount.tips', 'Log in or sign up to continue') }}</h2>
        <checkout-nav :step-numer="1" :step-count="navCount"/>
      </div>
    </div>

    <div class="PersoanlDetail_body flex">
      <div class="login">
        <div class="flex">
          <div class="left">
            <img src="../assets/images/profile_login.png" class="loginImg">
          </div>
          <div class="right">
            <p class="createAccount_tip">{{ $t('checkout.personalDetails.common.createAccount.login.tips', 'Already have an account?') }}</p>
            <p class="createAccount_subTip">{{ $t('checkout.personalDetails.common.createAccount.login.subTips', 'Log in with your Philips account') }}</p>
            <app-button
              @click.prevent="loginTask"
            >
              {{ $t('checkout.personalDetails.common.createAccount.button.login', 'Philips login') }}
            </app-button>
          </div>
        </div>

        <div
          class="privacyDeclaration hide-desktop hide-tablet"
          v-html="$t('checkout.privacyDeclaration.text', '')"></div>
      </div>
      <div class="createAccount">
        <div class="flex">
          <div class="left">
            <img src="../assets/images/profile_signUp.png" class="signUpImg">
          </div>
          <div class="right">
            
            <p class="createAccount_subTip">{{ $t('checkout.personalDetails.common.createAccount.signUp.subTips', 'Create your Philips account here') }}</p>
            <app-button
              @click.prevent="signUpTask"
            >
              {{ $t('checkout.personalDetails.common.createAccount.button.signUp', 'Sign up') }}
            </app-button>
          </div>
        </div>
      </div>
      <div
        class="privacyDeclaration hide-mobile"
        v-html="$t('checkout.privacyDeclaration.text', '')"></div>
    </div>
  </section>
</template>

<script>
  import CheckoutNav from './CheckoutNav'
  import auth from 'utilities/udi/udi'
  import { mapState } from 'vuex'

  export default {
    name: 'checkout-sign-up',

    components: {
      CheckoutNav
    },

    computed: {
      navCount () {
        if (this.disablePayment) {
          return 2
        } else {
          return 3
        }
      },

      ...mapState('checkout', {
        disablePayment: state => state.cartDetails.disablePayment
      })
    },

    methods: {
      async loginTask () {
        await auth.login()
      },

      async signUpTask () {
        await auth.signUp()
      }
    }
  }
</script>

<style lang="scss">
  .ReFPSignUp {
    border-bottom: .01rem solid #d6d6d6;
    padding-left: .12rem;

    @include media(tablet) {
      padding-bottom: .14rem;
    }

    .PersoanlDetail_header {
      .flex-between {
        margin: .3rem 0 .58rem;
      }

      .createAccount_title {
        font-size: .24rem;
        line-height: .31rem;
        letter-spacing: -.0002rem;
        font-weight: 700;
      }
    }

    .PersoanlDetail_body {
      @include media(tablet) {
        justify-content: space-between;
      }

      .login,
      .createAccount {
        width: 100%;

        @include media(tablet) {
          width: 48%;
        }

        .flex {
          border: .01rem solid #f5f5f5;
          padding: .28rem 0 .05rem .25rem;
          width: 100%;
          margin: 0 0 .2rem;
          flex-flow: row nowrap;
          display: inline-block;

          @include media(tablet) {
            display: flex;
            padding: .28rem 0 .05rem .1rem;
          }
        }

        .left {
          border-radius: 50%;
          border: .01rem solid #f5f5f5;
          width: .5rem;
          height: .5rem;
          margin: 0 0 .26rem;

          @include media(tablet) {
            margin: .28rem .1rem 0 0;
          }

          .loginImg {
            display: inline-block;
            margin: 28%;
          }

          .signUpImg {
            display: inline-block;
            margin-top: 28%;
            margin-left: 21%;
          }
        }

        .AppButton {
          font-size: .14rem;
          line-height: .2rem;
          padding: .07rem .24rem;
          width: auto;
          max-width: 100%;
          margin-bottom: .19rem;
        }
      }

      .createAccount {
        &_tip {
          font-size: .21rem;
          line-height: .26rem;
          letter-spacing: -.0002rem;
          font-weight: 400;
          color: #323232;
        }

        &_subTip {
          font-size: .14rem;
          line-height: .22rem;
          font-weight: 400;
          color: #3c3c3c;
          margin: .08rem 0 .14rem;
        }

        &_usp {
          .uspItem {
            display: flex;
            margin-bottom: .2rem;
            font-size: .14rem;
            font-weight: 400;
            line-height: .22rem;
            color: #3c3c3c;

            .icon-tick {
              margin-right: .08rem;
              flex-shrink: 0;
              color: #5b8f22;
            }
          }

          @include media(tablet) {
            margin-left: .1rem;
          }
        }
      }
    }

    .privacyDeclaration {
      padding: 0 0 .1rem;
    }
  }
</style>
